export const validateDate = /^(0[1-9]|[1-2][0-9]|3[0-1])\/(0[1-9]|1[0-2])\/([0-9][0-9][0-9][0-9])$/;
export const validateCompetence = /^(0[1-9]|1[0-2])\/([0-9][0-9][0-9][0-9])$/;
export const validateUrl = /^(http|https):\/\//;
export const validateHex = /^#[0-9a-fA-F]{6}$/;
